// extracted by mini-css-extract-plugin
export var chip = "_p2-2";
export var chipBody = "_p2-8";
export var chipHeader = "_p2-9";
export var chipWithKind = "_p2-7";
export var icon = "_p2-3";
export var kind = "_p2-a";
export var remove = "_p2-5";
export var removeIcon = "_p2-6";
export var row = "_p2-0";
export var rowHistorical = "_p2-1";
export var text = "_p2-4";